import { fetchQuery, graphql } from "relay-runtime"
import {
  parseNodeIdQuery,
  parseNodeIdQuery$data,
} from "@/modules/admin/advanced/services/__generated__/parseNodeIdQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query parseNodeIdQuery($nodeId: String!) {
    parseNodeId(nodeId: $nodeId) {
      typeName
      internalId
      internalIdRuntimeType
    }
  }
`

export type ParsedNodeId = NonNullable<parseNodeIdQuery$data["parseNodeId"]>

export const fetchParsedNodeId = (nodeId: string): Promise<ParsedNodeId | null> =>
  fetchQuery<parseNodeIdQuery>(RelayEnvironment, query, { nodeId }, { fetchPolicy: "network-only" })
    .toPromise()
    .then((response) => response?.parseNodeId ?? null)
